class FlexColors {
  static primary = "#E85426";
}

export default FlexColors;
